// The engine drops a `columns` nested in a column (migrated image next to text),
// so each one is wrapped in a `container`, which it renders as a row; load after the engine
(function (w) {
  'use strict';

  if (!w.NewsNeo || typeof w.NewsNeo.render !== 'function') return;

  function wrapNestedColumns(el) {
    if (!el || typeof el !== 'object' || !Array.isArray(el.children)) return el;
    var children = el.children.map(function (child) {
      child = wrapNestedColumns(child);
      if (el.type === 'columns' && child && child.type === 'columns') {
        // Keep the column slot so the engine buckets the wrapper where the original sat
        var slot = child.content && child.content.columnIndex;
        return { id: child.id, type: 'container', content: { columnIndex: slot }, children: [child] };
      }
      return child;
    });
    var copy = {};
    for (var key in el) copy[key] = el[key];
    copy.children = children;
    return copy;
  }

  // The old builder turned newlines into <br>; imported markup is only indented, and those
  // newlines sit at a text node's edges, so just the interior ones become breaks
  function breakLines(html) {
    return html.replace(/(<[^>]*>)|([^<]+)/g, function (m, tag, text) {
      if (tag) return tag;
      if (text.trim() === '') return text;
      return text
        .replace(/^\s*\n\s*/, ' ')
        .replace(/\s*\n\s*$/, ' ')
        .replace(/\n/g, '<br>');
    });
  }

  function restoreLineBreaks(el) {
    if (!el || typeof el !== 'object') return el;
    var copy = {};
    for (var key in el) copy[key] = el[key];
    var content = el.content;
    if (el.type === 'text' && content && typeof content.text === 'string' && content.text.indexOf('\n') > -1) {
      var c = {};
      for (var k in content) c[k] = content[k];
      c.text = breakLines(content.text);
      copy.content = c;
    }
    if (Array.isArray(el.children)) copy.children = el.children.map(restoreLineBreaks);
    return copy;
  }

  // The engine never reads localeOverrides, so other languages showed the base text; an element's
  // override content is laid over its base, picked by exact key, then language, then language_*
  function localeBucket(neo, locale) {
    var overrides = neo && neo.localeOverrides;
    if (!locale || !overrides || typeof overrides !== 'object') return null;
    var lang = String(locale).split(/[-_]/)[0].toLowerCase();
    if (String(neo.baseLocale || '').toLowerCase().split(/[-_]/)[0] === lang) return null;
    var bucket = overrides[locale] || overrides[lang];
    if (!bucket) {
      for (var key in overrides) {
        if (key.toLowerCase().indexOf(lang + '_') === 0) { bucket = overrides[key]; break; }
      }
    }
    return bucket && bucket.elements && typeof bucket.elements === 'object' ? bucket.elements : null;
  }

  function localizeElement(el, entries) {
    if (!el || typeof el !== 'object') return el;
    var entry = el.id && entries[el.id];
    var override = entry && entry.content && typeof entry.content === 'object' && !Array.isArray(entry.content) ? entry.content : null;
    var hasChildren = Array.isArray(el.children);
    if (!override && !hasChildren) return el;
    var copy = {};
    for (var key in el) copy[key] = el[key];
    if (override) {
      var content = {};
      for (var b in el.content || {}) content[b] = el.content[b];
      for (var o in override) content[o] = override[o];
      copy.content = content;
    }
    if (hasChildren) copy.children = el.children.map(function (child) { return localizeElement(child, entries); });
    return copy;
  }

  function localizeSection(section, entries) {
    if (!entries || !section || !Array.isArray(section.elements)) return section;
    var copy = {};
    for (var key in section) copy[key] = section[key];
    copy.elements = section.elements.map(function (el) { return localizeElement(el, entries); });
    return copy;
  }

  function pageLocale() {
    var mount = document.getElementById('aico-content');
    // news is drawn without a mount, so the page language decides there
    return (mount && mount.getAttribute('data-aico-locale')) || document.documentElement.lang || '';
  }

  // The engine drops section styles, so a migrated hero heading lost its background picture;
  // the heading is swapped for an html block that carries the picture and keeps the heading's own colour
  function heroBackground(section) {
    var st = section && section.styles && section.styles.desktop;
    if (!st || Array.isArray(st) || typeof st.backgroundImage !== 'string') return '';
    var m = st.backgroundImage.match(/url\(\s*["']?([^"')]+)["']?\s*\)/i);
    return m ? m[1] : '';
  }

  // Older imports lack the legacyHeroHeading flag, so a pictured section that opens with a heading counts
  function isHeroSection(section) {
    var first = section && Array.isArray(section.elements) && section.elements[0];
    return !!(heroBackground(section) && first && first.type === 'heading');
  }

  // A text right after the title was the old block's subtitle box; without one that box was an empty dot
  function restoreHeroBackground(section) {
    if (!isHeroSection(section)) return section;
    var src = heroBackground(section);
    var el = section.elements[0];
    var next = section.elements[1];
    var subtitle = next && next.type === 'text' && next.content && typeof next.content.text === 'string' ? next.content.text : '';
    var content = el.content || {};
    var level = /^h[1-6]$/i.test(content.level || '') ? content.level : 'h2';
    var own = el.styles && el.styles.desktop;
    var color = (own && !Array.isArray(own) && own.color) || content.legacyTitleColor || '';
    var style = color ? ' style="color:' + String(color).replace(/[";<>]/g, '') + '"' : '';
    var text = String(content.text != null ? content.text : '').replace(/^\s*<p[^>]*>([\s\S]*?)<\/p>\s*$/i, '$1');
    var middle = section.legacyHeroHeading && section.legacyHeroHeading.middle;
    var html = '<div class="aico-hero-heading' + (middle ? ' aico-hero-heading--middle' : '') + '" style="background-image:url(' + encodeURI(src).replace(/[()'"]/g, escape) + ')">' +
      '<div class="aico-hero-heading__content">' +
      '<' + level + style + '>' + text + '</' + level + '>' +
      '<div class="aico-hero-heading__subtitle"' + style + '>' + subtitle + '</div>' +
      '</div></div>';
    var copy = {};
    for (var key in section) copy[key] = section[key];
    copy.elements = [{ id: el.id, type: 'html', content: { html: html } }].concat(section.elements.slice(subtitle ? 2 : 1));
    return copy;
  }

  // The engine drops a section's background colour too, so each of its rows carries a marker
  // that paintRowBackgrounds turns into the colour on the rendered row
  function sectionBackgroundColor(section) {
    var st = section && section.styles && section.styles.desktop;
    var color = st && !Array.isArray(st) && typeof st.backgroundColor === 'string' ? st.backgroundColor.trim() : '';
    return /^[#\w(),.%\s-]+$/.test(color) ? color : '';
  }

  function markRowBackgrounds(section) {
    var color = sectionBackgroundColor(section);
    if (!color || !Array.isArray(section.elements)) return section;
    var marker = function (slot) {
      return { type: 'html', content: { html: '<i data-aico-row-bg="' + color + '"></i>', columnIndex: slot } };
    };
    var elements = [];
    var inRow = false;
    section.elements.forEach(function (el) {
      if (el && el.type === 'columns') {
        var copy = {};
        for (var key in el) copy[key] = el[key];
        copy.children = [marker(0)].concat(Array.isArray(el.children) ? el.children : []);
        elements.push(copy);
        inRow = false;
        return;
      }
      if (!inRow) elements.push(marker());
      inRow = true;
      elements.push(el);
    });
    var out = {};
    for (var k in section) out[k] = section[k];
    out.elements = elements;
    return out;
  }

  function paintRowBackgrounds(html) {
    if (!html || html.indexOf('data-aico-row-bg') < 0) return html;
    var box = document.createElement('div');
    box.innerHTML = html;
    var marks = box.querySelectorAll('[data-aico-row-bg]');
    for (var i = 0; i < marks.length; i++) {
      var row = marks[i].closest('.content-row');
      if (row) row.style.backgroundColor = marks[i].getAttribute('data-aico-row-bg');
      var holder = marks[i].closest('.content') || marks[i];
      if (holder.parentNode) holder.parentNode.removeChild(holder);
    }
    return box.innerHTML;
  }

  // The old product card was one link around picture, title and button; the engine drops an
  // image's linkUrl, so the title and button text are wrapped here and the picture after rendering
  function linkProductCards(section, imageLinks) {
    if (!section || !Array.isArray(section.elements)) return section;
    var url = '';
    var elements = section.elements.map(function (el) {
      var content = el && el.content;
      if (!content) return el;
      if (el.type === 'image' && typeof content.linkUrl === 'string' && content.linkUrl.trim()) {
        url = content.linkUrl.trim().replace(/"/g, '&quot;');
        if (content.src) imageLinks[content.src] = url;
        return el;
      }
      var isTitle = el.type === 'heading';
      var isButton = el.type === 'text' && /class="[^"]*button-product/.test(content.text || '');
      if (!url || typeof content.text !== 'string' || !(isTitle || isButton)) return el;
      var copy = {};
      for (var key in el) copy[key] = el[key];
      var c = {};
      for (var k in content) c[k] = content[k];
      c.text = isTitle
        ? '<a class="aico-card-link" href="' + url + '">' + content.text + '</a>'
        : content.text.replace(/(<div class="[^"]*button-product[^"]*">)([\s\S]*)(<\/div>\s*)$/, '$1<a href="' + url + '">$2</a>$3');
      copy.content = c;
      return copy;
    });
    if (!url) return section;
    var out = {};
    for (var s in section) out[s] = section[s];
    out.elements = elements;
    return out;
  }

  // The old builder put a picture in a left-anchored box as wide as its percentage and centred it
  // there, with the caption under it; the engine centres the picture in the whole column instead
  function boxImages(html, imageLinks) {
    if (!html || html.indexOf('content-type-neo-image') < 0) return html;
    var box = document.createElement('div');
    box.innerHTML = html;
    var imgs = box.querySelectorAll('.content-type-neo-image > img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var st = img.style;
      if (/%$/.test(st.maxWidth) && st.marginLeft === 'auto' && st.marginRight === 'auto') {
        img.parentNode.className += ' aico-image-box';
        img.parentNode.style.width = st.maxWidth;
        img.parentNode.style.textAlign = 'center';
        st.maxWidth = '100%';
        st.display = 'inline';
        st.marginLeft = '';
        st.marginRight = '';
      }
      var href = imageLinks[img.getAttribute('src')];
      if (href) {
        var a = document.createElement('a');
        a.className = 'aico-card-link';
        a.setAttribute('href', href.replace(/&quot;/g, '"'));
        img.parentNode.insertBefore(a, img);
        a.appendChild(img);
      }
    }
    return box.innerHTML;
  }

  // The engine ignores the button presets from the builder, so they are tagged for the css
  function collectButtonStyles(el, map) {
    if (!el || typeof el !== 'object') return map;
    var content = el.content;
    if (el.type === 'button' && content && typeof content.url === 'string' && content.buttonVariant) {
      map[content.url] = content.buttonVariant;
    }
    var children = Array.isArray(el.children) ? el.children : [];
    for (var i = 0; i < children.length; i++) collectButtonStyles(children[i], map);
    return map;
  }

  // The migration stamped 16:9 on slideshows, which letterboxes wide images; the slides size themselves
  function freeSlideshowHeight(html) {
    if (!html || html.indexOf('neo-slideshow__viewport') < 0) return html;
    var box = document.createElement('div');
    box.innerHTML = html;
    var views = box.querySelectorAll('.neo-slideshow__viewport');
    for (var i = 0; i < views.length; i++) {
      var style = (views[i].getAttribute('style') || '').replace(/aspect-ratio\s*:[^;]*;?/gi, '').trim();
      if (style) views[i].setAttribute('style', style); else views[i].removeAttribute('style');
      // without a fixed frame a lazy image leaves the track at zero height, so it never loads
      var imgs = views[i].querySelectorAll('img');
      for (var j = 0; j < imgs.length; j++) imgs[j].setAttribute('loading', 'eager');
    }
    return box.innerHTML;
  }

  function applyButtonStyles(html, map) {
    var keys = 0;
    for (var k in map) { keys++; break; }
    if (!html || !keys) return html;
    var box = document.createElement('div');
    box.innerHTML = html;
    var links = box.querySelectorAll('.content-type-neo-button a');
    for (var i = 0; i < links.length; i++) {
      var variant = map[links[i].getAttribute('href')];
      if (variant && links[i].parentNode) links[i].parentNode.setAttribute('data-aico-button', variant);
    }
    return box.innerHTML;
  }

  var render = w.NewsNeo.render;
  w.NewsNeo.render = function (data) {
    var neo = data && data.contentBuilderNeoJson;
    if (neo && Array.isArray(neo.sections)) {
      var imageLinks = {};
      var entries = localeBucket(neo, pageLocale());
      var sections = neo.sections.map(function (section) {
        if (!section || !Array.isArray(section.elements)) return section;
        section = localizeSection(section, entries);
        section = linkProductCards(markRowBackgrounds(restoreHeroBackground(section)), imageLinks);
        var copy = {};
        for (var key in section) copy[key] = section[key];
        copy.elements = section.elements.map(wrapNestedColumns).map(restoreLineBreaks);
        return copy;
      });
      var neoCopy = {};
      for (var k in neo) neoCopy[k] = neo[k];
      neoCopy.sections = sections;
      var dataCopy = {};
      for (var d in data) dataCopy[d] = data[d];
      dataCopy.contentBuilderNeoJson = neoCopy;
      data = dataCopy;
      var buttons = {};
      sections.forEach(function (section) {
        (section && section.elements ? section.elements : []).forEach(function (el) {
          collectButtonStyles(el, buttons);
        });
      });
      return posterYoutube(boxImages(paintRowBackgrounds(freeSlideshowHeight(applyButtonStyles(render.call(this, data), buttons))), imageLinks));
    }
    return posterYoutube(render.call(this, data));
  };

  // YouTube picks a small blurry preview for players under ~640px, so the HD one is shown instead
  // and the player loads on click
  function posterYoutube(html) {
    return html.replace(/<iframe([^>]*?)src="https:\/\/www\.youtube\.com\/embed\/([\w-]+)"[^>]*><\/iframe>/g, function (m, attrs, id) {
      var title = (attrs.match(/title="([^"]*)"/) || [])[1] || 'YouTube video';
      return '<button type="button" class="neo-yt-poster" data-yt-id="' + id + '" aria-label="' + title + '">' +
        '<img src="https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg" alt="" loading="lazy"></button>';
    });
  }

  // Videos without an HD preview get YouTube's 120px placeholder, those fall back to the standard one
  function fallbackPosters(root) {
    var imgs = (root || document).querySelectorAll('.neo-yt-poster img');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        var check = function () {
          if (img.naturalWidth > 120 || /hqdefault/.test(img.src)) return;
          img.src = img.src.replace('maxresdefault', 'hqdefault');
        };
        if (img.complete && img.naturalWidth) check();
        img.addEventListener('load', check);
        img.addEventListener('error', check);
      })(imgs[i]);
    }
  }

  document.addEventListener('click', function (e) {
    var poster = e.target.closest && e.target.closest('.neo-yt-poster');
    if (!poster) return;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + poster.getAttribute('data-yt-id') + '?autoplay=1';
    iframe.title = poster.getAttribute('aria-label') || 'YouTube video';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    poster.parentNode.replaceChild(iframe, poster);
  });

  // Migration stored each slide caption in `alt`, so mirror it into a visible bar like the old carousel
  function addSlideCaptions(root) {
    var slides = (root || document).querySelectorAll('.neo-slideshow__slide');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      var text = img && (img.getAttribute('alt') || '').trim();
      if (!text || slides[i].querySelector('.neo-slideshow__alt-caption')) continue;
      var bar = document.createElement('div');
      bar.className = 'neo-slideshow__alt-caption';
      bar.textContent = text;
      slides[i].appendChild(bar);
    }
  }

  var hydrate = w.NewsNeo.hydrate;
  if (typeof hydrate === 'function') {
    w.NewsNeo.hydrate = function (root) {
      var out = hydrate.apply(this, arguments);
      try { addSlideCaptions(root); } catch (e) { }
      try { fallbackPosters(root); } catch (e) { }
      return out;
    };
  }

  function needsFixing(el, inColumns) {
    if (!el || typeof el !== 'object') return false;
    if (inColumns && el.type === 'columns') return true;
    if (el.type === 'image') return true;
    var content = el.content;
    if (el.type === 'text' && content && typeof content.text === 'string' && content.text.indexOf('\n') > -1) return true;
    var children = Array.isArray(el.children) ? el.children : [];
    for (var i = 0; i < children.length; i++) {
      if (needsFixing(children[i], el.type === 'columns')) return true;
    }
    return false;
  }

  // A document over 65 000 bytes is stored as a url instead of the metafield, and the engine's
  // boot paints from the inline copy alone, so those pages render nothing
  (function paintFromUrl() {
    var el = document.getElementById('aico-content');
    if (!el || document.getElementById('aico-page-data') || el.innerHTML || typeof w.fetch !== 'function') return;
    var url = el.getAttribute('data-aico-neo-url');
    if (!url) return;
    w.fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (doc) {
        // the stored document is the bare body; the engine reads it under contentBuilderNeoJson
        var data = (doc && doc.contentBuilderNeoJson) ? doc : { contentBuilderNeoJson: doc };
        if (el.innerHTML || !w.NewsNeo.hasContent(data)) return;
        el.innerHTML = w.NewsNeo.render(data);
        if (typeof w.NewsNeo.hydrate === 'function') w.NewsNeo.hydrate(el);
        el.setAttribute('data-aico-neo-source', 'url');
      })
      .catch(function (e) {
        if (w.console && console.warn) console.warn('content-builder-neo-lasermed: url document failed', e);
      });
  })();

  // The engine already painted on load, so repaint once when that paint missed one of the fixes above
  var mount = document.getElementById('aico-content');
  var dataEl = document.getElementById('aico-page-data');
  if (!mount || !dataEl) return;
  try {
    var data = JSON.parse(dataEl.textContent || '{}');
    var sections = (data.contentBuilderNeoJson && data.contentBuilderNeoJson.sections) || [];
    var nested = !!localeBucket(data.contentBuilderNeoJson, pageLocale()) || sections.some(function (section) {
      return section && Array.isArray(section.elements) && (section.elements.some(function (el) {
        return needsFixing(el, false);
      }) || isHeroSection(section) || sectionBackgroundColor(section));
    });
    if (!nested || !w.NewsNeo.hasContent(data)) return;
    mount.innerHTML = w.NewsNeo.render(data);
    w.NewsNeo.hydrate(mount);
  } catch (e) {
    if (w.console && console.warn) console.warn('content-builder-neo-lasermed: repaint failed', e);
  }
})(window);
